<template>
    <div class="container">
        <template v-if="loader_loading">
            <br />
            <div class="text-center text-muted">
                <font-awesome-icon icon="fas fa-circle-notch" size="2x" spin />
                <p>Loading data</p>
            </div>
        </template>

        <template v-if="!voucher_list.length && !expired_voucher_list.length && !loader_loading">
            <div class="card">
                <div class="card-body">
                    <h4 class="text-muted text-center mb-0">No data available</h4>
                </div>
            </div>
        </template>

        <template v-if="!loader_loading">
            <template v-if="voucher_list.length">
                <!--                <div class="form-check form-switch mb-2">
                    <input class="form-check-input" type="checkbox" role="switch" id="showAllSwitch" v-model="is_show_all" @change="reloadUi()">
                    <label class="form-check-label" for="showAllSwitch">Show All</label>
                </div> -->

                <div class="row align-items-end mb-4">
                    <div v-for="record in voucher_list" class="col-4 mb-2 h-100">
                        <template v-if="record.status == 13">
                            <small>
                                <span :class="$parent.generateRecordStatusClass(record.status)" class="badge rounded-pill w-100">{{ record.status_str }}</span>
                            </small>
                        </template>

                        <template v-if="record.status != 13 && record.time_left">
                            <small class="text-center">
                                <span class="badge rounded-pill text-bg-danger w-100">{{ record.time_left }}</span>
                            </small>
                        </template>

                        <div @click="openBottomSheet('VIEW_DETAIL', record.id)" :class="{ 'cs-card-disabled': record.status != 11 }" class="card border-0 cs-shadow">
                            <!-- <div @click="goToRecordDetail(record.id)" :class="{ 'cs-card-disabled': record.status == 13 }" class="card"> -->
                            <img v-if="record.voucher_data.img_json && record.voucher_data.img_json['1_13']" :src="record.voucher_data.img_json['1_13']" class="img-fiuld rounded w-100 align-middle" />
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="expired_voucher_list.length">
                <h4 class="mb-0">Recently Expired</h4>
                <small class="text-body-secondary fst-italic">Only show expired voucher within 7 days</small>

                <div class="row align-items-end my-3">
                    <div v-for="record in expired_voucher_list" class="col-4 mb-2 h-100">
                        <!-- <div @click="goToRecordDetail(record.id)" class="card cs-card-disabled"> -->
                        <div class="card cs-card-disabled">
                            <img v-if="record.voucher_data.img_json && record.voucher_data.img_json['1_13']" :src="record.voucher_data.img_json['1_13']" class="card-img" />
                        </div>
                    </div>
                </div>
            </template>
        </template>

        <RecordDetail title="Voucher Detail" ref="voucher" :record_data="record_data">
        </RecordDetail>
    </div>
</template>

<script>
import RecordDetail from '../components/_bottom_sheet/RecordDetail.vue';

export default {
    components: {
        RecordDetail,
    },
    data() {
        return {
            is_show_all: true,
            voucher_list: [],
            record_data: {},
            expired_voucher_list: [],
            bottom_sheet: "",
            loader_loading: false,
        };
    },
    mounted() {
        this.initMainFunction();
    },
    methods: {
        initMainFunction() {
            this.loadData();
            return true;
        },

        loadData() {
            this.reloadUi();

            if (app.my_voucher_record_id) {
                this.openBottomSheet("VIEW_DETAIL", app.my_voucher_record_id);
            }

            return app.readExpiredRecord(app.device_tag).then((expired_voucher_list) => {
                this.loader_loading = false;

                if (!expired_voucher_list) {
                    return false;
                }

                this.expired_voucher_list = expired_voucher_list;
                return true;
            });
        },

        openBottomSheet(name, params = {}) {
            switch (name) {
                case "VIEW_DETAIL":
                    this.bottom_sheet = "";
                    this.qr_image = "";
                    this.record_data = {};

                    return app.readRecordDetail(app.device_tag, params).then(response_data => {
                        if (!response_data) {
                            return false;
                        }

                        this.record_data = response_data;

                        this.bottom_sheet = new bootstrap.Offcanvas(document.querySelector("#record_detail_bottom_sheet"));
                        this.bottom_sheet.show();
                        return true;
                    });

                    break;
            }
        },

        reloadUi() {
            this.loader_loading = true;
            let filter = "VALID";

            if (this.is_show_all) {
                filter = "ALL";
            }

            return app.readAllRecord(app.device_tag, null, filter, "EXPIRED_DATE").then((response_data) => {
                this.loader_loading = false;

                if (!response_data) {
                    return false;
                }

                this.voucher_list = response_data;
            });
        },

        goToRecordDetail(record_id) {
            app.record_id = record_id;
            app.redirectToRecordDetail();
        },
    },
};
</script>
